import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import { Grid, Divider } from '@mui/material';
import { ThemedTypography } from 'components/common/CommonStyles';
import { Typography } from '@totalsoft/rocket-ui';

export const FolderSummaryComponentBeta = ({ folderSummary, t }) => {
  return (
    <Grid container spacing={1} alignItems='center' p={3}>
      <Grid item xs={12}>
        <Typography fontWeight='bold' variant='subtitle1' textTransform='uppercase' gutterBottom>
          {t('Folder.Summary.Title')}
        </Typography>
      </Grid>
      {folderSummary.financedOffers?.map(financedOffer => {
        return (
          <React.Fragment key={financedOffer.offerId}>
            <Grid item xs={12} key={financedOffer.offerId}>
              <Typography fontWeight='bold'>{t('TaskList.Offer') + ' ' + financedOffer.documentNumber}</Typography>
            </Grid>
            {financedOffer.assets?.map((asset, index) => {
              return (
                <Grid item xs={12} key={index} ml={2}>
                  {asset.quantity + ' x ' + asset.name}
                </Grid>
              );
            })}
            <Grid item container ml={1} spacing={1}>
              <Grid item xs={12} sm={6}>
                {t('Folder.Summary.TotalAcquisitionPrice')}
              </Grid>
              <Grid item xs={12} sm={6} textAlign='end'>
                <span>
                  {financedOffer.currency} {t('DECIMAL', { number: financedOffer.totalAcquisitionPrice })}
                </span>
              </Grid>
              <Grid item xs={12} sm={6}>
                {t('Folder.Summary.ContractType')}
              </Grid>
              <Grid item xs={12} sm={6} textAlign='end'>
                <span>{financedOffer.contractType}</span>
              </Grid>
              <Grid item xs={12} sm={6}>
                {t('Folder.Summary.FinancedAmount')}
              </Grid>
              <Grid item xs={12} sm={6} textAlign='end'>
                <span>
                  {financedOffer.currency} {t('DECIMAL', { number: financedOffer.financedAmount })}
                </span>
              </Grid>
              <Grid item xs={12} sm={6}>
                {t('Folder.Summary.AdvancePercent')}
              </Grid>
              <Grid item xs={12} sm={6} textAlign='end'>
                <span>
                  {''} {t('PERCENT_NUMBER', { number: financedOffer.advancePercent })}
                </span>
              </Grid>
              <Grid item xs={12} sm={6}>
                {t('Folder.Summary.Period')}
              </Grid>
              <Grid item xs={12} sm={6} textAlign='end'>
                <span>{financedOffer.duration}</span>
              </Grid>
              
                  <Grid item xs={12} sm={6}>
                    {t('Folder.Summary.ResidualPercent')}
                  </Grid>
                  <Grid item xs={12} sm={6} textAlign='end'>
                    <span>
                      {''} {t('PERCENT_NUMBER', { number: financedOffer.rezidualPercent })}
                    </span>
                  </Grid>
              <Grid item xs={12} sm={6}>
                {t('Folder.Summary.SeasonalPaymentPlan')}
              </Grid>
              <Grid item xs={12} sm={6} textAlign='end'>
                <span>{financedOffer.hasCellParametrizationYN ? t('Folder.Summary.Yes') : t('Folder.Summary.No')}</span>
              </Grid>
              <Grid item xs={12} sm={6}>
                {t('Folder.Summary.GracePeriod')}
              </Grid>
              <Grid item xs={12} sm={6} textAlign='end'>
                <span>{financedOffer.gracePeriod ? t('Folder.Summary.Yes') : t('Folder.Summary.No')}</span>
              </Grid>
            </Grid>
          </React.Fragment>
        );
      })}
      <Grid item xs={12}>
        <Divider />
      </Grid>
      <Grid item xs={12} sm={6}>
        <ThemedTypography color='error' fontWeight='bold'>
          {t('Folder.Summary.ExistingExposure')}
        </ThemedTypography>
      </Grid>
      <Grid item xs={12} sm={6}>
        <ThemedTypography color='error' fontWeight='bold' textAlign='end'>
          {t('DECIMAL', { number: folderSummary.totalClientExposure })}
        </ThemedTypography>
      </Grid>
      <Grid item xs={12} sm={6}>
        <ThemedTypography color='error' fontWeight='bold'>
          {t('Folder.Summary.GroupExposure')}
        </ThemedTypography>
      </Grid>
      <Grid item xs={12} sm={6}>
        <ThemedTypography color='error' fontWeight='bold' textAlign='end'>
          {t('DECIMAL', { number: folderSummary.totalGroupExposure })}
        </ThemedTypography>
      </Grid>
      <Grid item xs={12} sm={6}>
        <ThemedTypography color='success'>{t('Folder.Summary.ScoringResult')}</ThemedTypography>
      </Grid>
      <Grid item xs={12} sm={6}>
        <ThemedTypography color='success' textAlign='end'>
          {t('DECIMAL', { number: folderSummary.scoringResult })}
        </ThemedTypography>
      </Grid>
      <Grid item xs={12} sm={6}>
        <ThemedTypography color='success'> {t('Folder.Summary.ScoringClass')}</ThemedTypography>
      </Grid>
      <Grid item xs={12} sm={6}>
        <ThemedTypography color='success' textAlign='end'>
          {folderSummary.scoringClass}
        </ThemedTypography>
      </Grid>
    </Grid>
  );
};
FolderSummaryComponentBeta.propTypes = {
  folderSummary: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired
};

export default compose(withTranslation())(FolderSummaryComponentBeta);
